import { render, staticRenderFns } from "./zhaopinxiangqing0-0.vue?vue&type=template&id=2c1f6ad0&scoped=true&"
import script from "./zhaopinxiangqing0-0.vue?vue&type=script&lang=js&"
export * from "./zhaopinxiangqing0-0.vue?vue&type=script&lang=js&"
import style0 from "./zhaopinxiangqing0-0.vue?vue&type=style&index=0&id=2c1f6ad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f6ad0",
  null
  
)

export default component.exports